// extracted by mini-css-extract-plugin
module.exports = {"galleryContainer":"Gallery_galleryContainer__2X8fG","gallery":"Gallery_gallery__sKr2o","prevBtn":"Gallery_prevBtn__2SikV","nextBtn":"Gallery_nextBtn__1kWGT"};